import { Injectable } from '@angular/core';
// import { Http, Headers } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@app-environments/environment';
import { AppService } from '@app-services/app.service';

@Injectable()
export class HttpHeaderService {

	_sessionId: number = Math.floor(Math.random() * 10000000000000000);

	constructor(
		private _appService: AppService,
	) {
	}

	// ========= Token ===============

	getAccessToken() {
		return this._appService.accessToken;
	}

	getNormalHttpHeader() {
		const option = {
			'Content-Type': 'application/json; charset=utf-8',
		};
		return new HttpHeaders(option);
	}

	getHttpHeader(initAccessToken = null) {
		let accessToken = this.getAccessToken();
		if (initAccessToken) {
			accessToken = initAccessToken;
		}
		if (!accessToken){
			return null;
		}else{
			const option = {
				'Content-Type': 'application/json; charset=utf-8',
				'Authorization': 'Bearer ' + accessToken,
				'X-Path-Session-Id': ('' + this._sessionId),
			};
			return new HttpHeaders(option);
		}
	}

	getHeader() {
		if (!this.getAccessToken()) return null;

		const option = {
			'Content-Type': 'application/json; charset=utf-8',
			'Authorization': 'Bearer ' + this.getAccessToken(),
			'X-Path-Session-Id': ('' + this._sessionId),
		};
		return new Headers(option);
	}

	getHttpFormHeader() {
		if (!this.getAccessToken()) return null;

		const option = {
			'Authorization': 'Bearer ' + this.getAccessToken(),
			'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
		};
		return new HttpHeaders(option);
	}
}
